import AboutArea from "./AboutArea";
import AboutStory from "./AboutStory";
import Wrapper from "@/layouts/Wrapper";
import Breadcrumb from "@/common/Breadcrumb";
import CtaHomeOne from "../homes/home-1/CtaHomeOne";
import FooterOne from "@/layouts/footers/FooterOne";
import HeaderOne from "@/layouts/headers/HeaderOne";
import IntegrationHomeOne from "../homes/home-1/IntegrationHomeOne";
import { useI18n } from "@/common/I18nProvider";

export default function Aboutus() {
  const { messages } = useI18n();
  const about = messages?.about || { subtitle: "من نحن" };

  return (
    <Wrapper>
      <HeaderOne />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <Breadcrumb title={about.subtitle} pageLink={about.subtitle} />
          <AboutArea />
          <IntegrationHomeOne />
          <AboutStory />
          <CtaHomeOne />
          <FooterOne />
        </div>
      </div>
    </Wrapper>
  )
}
